<template>
	<div class="merchandise container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>OVERVIEW HRGA</h4>
			</div>

			<div class="col-md-12">
				<div class="row">
					<div class="col-md-12">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>DATA PEGAWAI (YTD {{ this.tahun }})</H6>
							</div>
							<div class="card-body p-3 pt-0" style="width:100%;">
								<BarChart v-loading.body="loading.barchart" :data="barchartdata" :width="500" :height="380"  />
							</div>
						</div>
                    </div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>DATA PEGAWAI RESIGN (YTD {{ this.tahun }})</H6>
							</div>
							<div class="card-body p-3 pt-0" style="width:100%;">
								<BarChart v-loading.body="loading.barchartresign" :data="barchartresigndata" :width="500" :height="380"  />
							</div>
						</div>
                    </div>
				</div>

				<div class="row">
					<div class="col-md-4">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>PEGAWAI BERDASARKAN VENDOR (YTD {{ this.tahun }})</H6>
							</div>
							<div class="card-body p-3 pt-0 mt-2" style="width:90%;">
								<Doughnut v-loading.body="loading.piechart" :data="piechartdata"
									:url="''" :showlegend="false"/>
							</div>
						</div>
                    </div>


					<div class="col-md-4" v-if="false">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>PEGAWAI BERDASARKAN PENDIDIKAN TERAKHIR (YTD {{ this.tahun }})</H6>
							</div>
							<div class="card-body p-3 pt-0 mt-2" style="width:90%;">
								<Doughnut v-loading.body="loading.piechart" :data="piechartdatabyjenjang"
									:url="''"/>
							</div>
						</div>
                    </div>

					<div class="col-md-4" v-for="(vendorData, index) in pieChartByVendorData" :key="index">
						<div class="card cardptpr mb-4">
							<div class="card-header cardptpr p-3 pb-0 pt-0">
								<H6>PEGAWAI BERDASARKAN JABATAN<br>{{ vendorData.vendor }}</H6>
							</div>
							<div class="card-body p-3 pt-0 mt-2" style="width:90%;">
								<Doughnut  :data="generatePieChartData(vendorData.data)"
									:url="''" :showlegend="false"/>
							</div>
						</div>
                    </div>

				</div>

				<div class="row" v-if="false">
					<div class="col-md-4 mb-4">
						<ListItem class=" mb-4" title="PEGAWAI BERDASARKAN JABATAN (YTD)" :data="bestsellingproduct" itemcol="Jabatan" valuecol="TotalPegawai"
							url=""/>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import Basic from '@/components/page/Basic.js'
import Footer from '@/views/Footer.vue'
import { Rainbow, Rainbow2, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import LineChart from '@/components/chart/LineChart.js'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'
import Doughnut from '@/components/chart/Doughnut.js'
import ListItem from '@/views/pages/ListItem.vue'

export default{
	extends: Basic,
	components:{
		//PieChart,
		Doughnut,
		BarChart,
		ListItem,
	},
	data() {
		return {
			pldate: this.$route.query.pldate ? this.$route.query.pldate : null,
			urlRequestParams: '',
			barchartdata: [],
			piechartdata: [],
			barchartresigndata: [],
			piechartdatabyjenjang: [],
			bestsellingproduct: [],
			dateRange: [Penanggalan().tahunSekarang, Penanggalan().kemarin],
			tahun: Penanggalan().tahun,
			period: '',
			loading: {
				barchart: false,
				piechart: false,
				barchartresign: false,
			},

			pieChartByVendorData: [],
            isChildRoute: false,
		}
	},
    mounted() {
        this.hideNonChildren();
		this.getBarchart()
		this.getBarchartResign()
		this.getPiechart()
		//this.getPiechartByJenjang()
		//this.getListJabatan()

//		this.getPieChartGroupByJabatan()
    },
    watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/hrga';
        },
		getBarchart(){
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/hrga/pegawai-monthly-overview?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.barchart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				let chartresponsedata = response.data.data;
				this.barchartdata = this.processBarChart(chartresponsedata, "VendorName", "", "TotalPegawai", false, "period", "", 1, 2, Rainbow, false, false, false, true);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.barchart = false;
			})

		},

		getBarchartResign(){
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/hrga/pegawai-resign-monthly-overview?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.barchartresign = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				let chartresponsedata = response.data.data;
				this.barchartresigndata = this.processBarChart(chartresponsedata, "VendorName", "", "TotalPegawai", false, "period", "", 1, 2, Rainbow, false, false, false, true);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.barchartresign = false;
			})

		},

		getPiechart() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/hrga/pegawai-by-vendor?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);

				let responsedata = response.data.data

				//console.log('responsedata v: ' + JSON.stringify(responsedata))

				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].VendorName] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].VendorName,
						amount: item[row].TotalPegawai,
					};

					value.push(main);
					idx++;
				}

				this.piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},
		getPiechartByJenjang() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/hrga/pegawai-by-jenjang?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.piechart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				//this.chartresponsedata = response.data.data;
				//this.chartdata = this.processBarChart(this.chartresponsedata, "legend", "", "price", false, "period", "", 1, 2, Rainbow, false, false, false, this.stacked);

				let responsedata = response.data.data

				let item = responsedata
				var warna = []
				let value = [];
				let idx = 0;
				for (var row in item) {
					//add color
					warna[item[row].PEND_Jenjang] = Rainbow[idx];//'#FFB22E'

					//add value
					let main = {
						transtype: item[row].PEND_Jenjang,
						amount: item[row].TotalPegawai,
					};

					value.push(main);
					idx++;
				}

				this.piechartdatabyjenjang = this.processPieChart(value, "amount", "transtype", 1, 2, warna);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.piechart = false;
			})

		},
		getListJabatan(){
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/hrga/pegawai-by-jabatan?'

			this.urlRequestParams+='&date-range-start='+ this.dateRange[0]
			this.urlRequestParams+='&date-range-end='+ this.dateRange[1]
			this.urlRequestParams+='&period='+this.period

			this.loading.barchart = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				this.bestsellingproduct = response.data.data;
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				this.loading.barchart = false;
			})

		},

		getPieChartGroupByJabatan() {
			this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/hrga/pegawai-group-by-jabatan?'

			//this.loading.barchartresign = true;
			AxiosWithJar().get(this.urlRequestParams)
			.then((response)=>{
				let chartresponsedata = response.data.data;
				this.pieChartByVendorData = chartresponsedata;
				//this.barchartresigndata = this.processBarChart(chartresponsedata, "VendorName", "", "TotalPegawai", false, "period", "", 1, 2, Rainbow, false, false, false, true);
			})
			.catch(/*error => {
					//console.log(error)
					//this.errored = true
					//error.response.data
			}*/)
			.finally(() => {
				//this.loading.barchartresign = false;
			})
		},

		generatePieChartData(responsedata) {
			//console.log('responsedata: ' + JSON.stringify(responsedata))
			let item = responsedata
			var warna = [];
			let value = [];

			let idx = 0;
			for (var row in item) {
				//console.log('item[row].Jabatan:  ' + item[row].Jabatan)
				//add color
				//warna[item[row].Jabatan] = Rainbow[idx];//'#2EFF8F'
				let title = item[row]['Jabatan'];
				warna[title] = Rainbow[idx % Rainbow.length]; // Menggunakan modulus untuk kembali ke indeks awal jika Rainbow kurang dari item.length
				//Rainbow[idx];//'#FFB22E'

				//add value
				let main = {
					transtype: title,
					amount: item[row].Cnt,
				};

				value.push(main);
				idx++;
			}

			let piechartdata = this.processPieChart(value, "amount", "transtype", 1, 2, warna);

			return piechartdata;
		}

	}
}

</script>
